import PropTypes from 'prop-types'

/**
 * @typedef {Object} customerContactPositionPropType
 * @property {string} [id]          - The id of the contact position
 * @property {string} [stringCode]  - String code for the translation of the position
 */
export const customerContactPositionPropType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    stringCode: PropTypes.string.isRequired
})
